/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractResourceService } from '@irian-ro/abstract-resource';
import { Observable } from 'rxjs';
import { ETransportOperationPlacesTypesVO } from '@well/delivery-libs/etransport/domain-model';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable({
  providedIn: 'root'
})
export class ETransportOperationPlacesTypesResourceService extends AbstractResourceService<any, any, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('eTransportOperationPlacesTypesUrl'),
      null,
      null
    );
  }

  getOperationPlacesTypesForOperationTypeCode(operationTypeCode: string): Observable<ETransportOperationPlacesTypesVO[]>{
    return <Observable<ETransportOperationPlacesTypesVO[]>>this.httpClient?.get(`${this.url}/${operationTypeCode}`);
  }

}
